import React, { Fragment, useEffect } from 'react';
import {
    setAppCustomTitle
} from "../../reducers/ThemeOptions";
import { connect } from "react-redux";
import { getLoginUserInfo, validateLogin } from '../../Common/Appcommon';
import { useAppContext } from '../../Context/AppContext';
import { useLanguage } from '../../Context/LanguageContext';

const Login = (props) => {
    const useThemeFunc = useAppContext();
    const useLanguageFunc = useLanguage();

    useEffect(() => {
        (async () => {
            await validateLogin(props.history, true, useThemeFunc, useLanguageFunc);
            
        })();
        return () => {
            // this now gets called when the component unmounts
        };
    }, []);


    return (
        <Fragment>
            <div >
                Loading
            </div>

        </Fragment>
    )
}

const mapStateToProps = state => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle
});

const mapDispatchToProps = dispatch => ({
    setAppCustomTitle: title => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);